
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","rx":"4","fill":"#5E0DF5"}}),_c('path',{attrs:{"d":"M12 13L9.986 9.979c1.189-.45 1.868-1.453 1.868-2.842C11.854 5.183 10.52 4 8.312 4H5v9h1.213v-2.739h2.099c.182 0 .364-.012.534-.025L10.678 13H12zM8.276 9.169H6.213v-4.05h2.063c1.552 0 2.365.732 2.365 2.018 0 1.286-.813 2.032-2.365 2.032z","fill":"#fff"}})])
          )
        }
      }
    